export default "__VITE_ASSET__8Zb3pUz1__"